import { isMobileDevice } from '_metronic/assets/ts/_utils'

interface Props {
	label: string
	date: string
	done: boolean
}

const DeliveryItem: React.FC<Props> = ({ label, date, done }) => {
	return (
		<div
			className={`mb-2`}
			style={
				isMobileDevice()
					? {
							width: '80%',
					  }
					: {}
			}>
			<div className="d-flex flex-row align-items-start" style={{ gap: '10px' }}>
				<img
					className="mt-1"
					src="/media/icons/kumopack/delivery-grey-circle.svg"
					alt="Delivery Item Icon"
				/>

				<div className={done ? 'text-kumopack-grey-600' : 'text-kumopack-grey-400'}>
					{label}

					<div className="text-kumopack-grey-400">{date}</div>
				</div>
			</div>
		</div>
	)
}

export default DeliveryItem
